import { render, staticRenderFns } from "./PortalStatistics.vue?vue&type=template&id=669729c4&scoped=true"
import script from "./PortalStatistics.vue?vue&type=script&lang=js"
export * from "./PortalStatistics.vue?vue&type=script&lang=js"
import style0 from "./PortalStatistics.vue?vue&type=style&index=0&id=669729c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669729c4",
  null
  
)

export default component.exports